// extracted by mini-css-extract-plugin
export default {"navBlock":"Navbar_navBlock__7glJx","navbar":"Navbar_navbar__AHaSr","items":"Navbar_items__tFun4","item":"Navbar_item__T04AK","portfolioIcon":"Navbar_portfolioIcon__HEq3I"};